export enum UserAccessLevel {
  ADMIN = 1,
  EDITOR = 2,
  VIEWER = 3,
}
